import { combineReducers } from 'redux';
import zmanimReducer from './zmanimReducer';
import shabbatReducer from './shabbatReducer';
import authReducer from './authReducer';
import dashboardReducer from './dashboardReducer';
import organizationReducer from './organizationSetupReducer';
import weatherReducer from './weatherReducer';
import screensReducer from './screensReducer';
import publicScreenReducer from './publicScreenReducer';
import appReducer from './appReducer';
import moadReducer from './moadReducer';
import tefilotReducer from './tefilotReducer';
import parnasReducer from './parnasReducer';
import licenseReducer from './licenseReducer';
import omerReducer from './omerReducer';
import halachicEngineReducer from './halachicEngineReducer';

export default combineReducers({
  zmanim: zmanimReducer,
  shabbat: shabbatReducer,
  moad: moadReducer,
  tefilot: tefilotReducer,
  parnas: parnasReducer,
  omer: omerReducer,
  auth: authReducer,
  dashboard: dashboardReducer,
  organization: organizationReducer,
  weather: weatherReducer,
  screens: screensReducer,
  publicScreen: publicScreenReducer,
  app: appReducer,
  license: licenseReducer,
  halachicEngine: halachicEngineReducer,
});